import { useCallback, useRef } from 'react';

export function usePickMediaFile() {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const pickMedia = useCallback((type?: 'camera' | 'album', accept?: string) => {
    if (!inputRef.current) return;

    if (type === 'camera') {
      inputRef.current.setAttribute('capture', 'camera');
    } else {
      inputRef.current.removeAttribute('capture');
    }

    if (accept) {
      inputRef.current.setAttribute('accept', accept);
    } else {
      inputRef.current.removeAttribute('accept');
    }
    inputRef.current.click();
  }, []);

  return {
    ref: inputRef,
    pickMedia,
  } as const;
}
